import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "space-y-9" }
const _hoisted_3 = { class: "grid grid-cols-4 gap-6" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = { class: "flex justify-center gap-6" }

import { watch } from 'vue';
import { useRoute } from 'vue-router';

import Button from 'primevue/button';
import Card from 'primevue/card';

import { useSegmentSelection } from '../composables/useSegmentSelection';


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectSegmentView',
  setup(__props) {

const { selectedSegmentId, unrequiredSegments, handleNextView } = useSegmentSelection();

const route = useRoute();
watch(
  () => route.path,
  () => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 50);
  },
  {
    immediate: true,
  }
);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createBlock(_unref(Card), { class: "h-max flex-1 basis-[354px] border border-gray-200 !shadow-none" }, {
    content: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(unrequiredSegments), (segment) => {
              return (_openBlock(), _createElementBlock("button", {
                key: segment.id,
                class: _normalizeClass(["flex flex-col items-center gap-4 rounded-[10px] border p-6 transition-colors", {
                'border-brand-300 bg-brand-50 text-brand-500': _unref(selectedSegmentId) === segment.id,
                'border-gray-200 bg-white text-gray-800 hover:border-brand-300 hover:bg-brand-50 hover:text-brand-500':
                  _unref(selectedSegmentId) !== segment.id,
              }]),
                onClick: ($event: any) => (selectedSegmentId.value = segment.id)
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(segment.name), 1)
              ], 10, _hoisted_4))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_RouterLink, {
              to: {
                name: 'CalculationSummaryView',
                params: {
                  ..._ctx.$route.params,
                },
              }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  class: "font-semibold",
                  severity: "secondary",
                  outlined: "",
                  size: "small"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode(" Wstecz ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_unref(Button), {
              class: "font-semibold",
              size: "small",
              disabled: !_unref(selectedSegmentId),
              onClick: _unref(handleNextView)
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode(" Dodaj technologię "),
                _createElementVNode("i", { class: "pi pi-arrow-right" }, null, -1)
              ])),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ])
      ])), [
        [_directive_auto_animate]
      ])
    ]),
    _: 1
  }))
}
}

})